module.exports = __webpack_public_path__ + "static/media/31.5cd65dec.svg";